module.exports = __webpack_public_path__ + "img/banner.b04be46c.jpg";